export const version = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    isResumeUpload: ''
  },
  getters: {
    isResumeUpload: state => state.isResumeUpload
  },
  mutations: {
    setIsResumeUpload(state, payload) {
      state.isResumeUpload = payload;
    }
  },
  actions: {
    setIsResumeUpload(context, payload) {
      context.commit('setIsResumeUpload', payload);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/version.js